import store from '@/store';
import Vue from 'vue';
import Router from 'vue-router';

// const i18n  = () => import('@/lang/lang';

// Module: Landing
const LandingScreen = () =>
  import(
    /* webpackChunkName: "landingScreen" */ '@/components/modules/landing/LandingScreen'
  );
const AboutUsScreen = () =>
  import(
    /* webpackChunkName: "aboutUs" */ '@/components/modules/landing/footerComponents/AboutUs'
  );
const CareerScreen = () =>
  import(
    /* webpackChunkName: "career" */ '@/components/modules/landing/footerComponents/Career'
  );
const PressScreen = () =>
  import(
    /* webpackChunkName: "press" */ '@/components/modules/landing/footerComponents/Press'
  );
const PrivacyScreen = () =>
  import(
    /* webpackChunkName: "privacyPolicy" */ '@/components/modules/landing/footerComponents/PrivacyPolicy'
  );
const GeneralTermsScreen = () =>
  import(
    /* webpackChunkName: "generalTerms" */ '@/components/modules/landing/footerComponents/GeneralTerms'
  );
const TeamScreen = () =>
  import(
    /* webpackChunkName: "team" */ '@/components/modules/landing/components/Team'
  );
const BusinessScreen = () =>
  import(
    /* webpackChunkName: "business" */ '@/components/modules/landing/footerComponents/Business'
  );
const PricingScreen = () =>
  import(
    /* webpackChunkName: "pricing" */ '@/components/modules/landing/footerComponents/Pricing'
  );
const SubscribeScreen = () =>
  import(
    /* webpackChunkName: "subscribe" */ '@/components/modules/landing/components/Subscribe'
  );
const UnsubscribedScreen = () =>
  import(
    /* webpackChunkName: "unsubscribed" */ '@/components/modules/landing/components/Unsubscribed'
  );
const UnsubscribeChooserScreen = () =>
  import(
    /* webpackChunkName: "unsubscribeChooser" */ '@/components/modules/landing/components/UnsubscribeChooser'
  );
const InvitationScreen = () =>
  import(
    /* webpackChunkName: "invitationScreen" */ '@/components/modules/landing/InvitationScreen'
  );
const ChurnScreen = () =>
  import(
    /* webpackChunkName: "churn" */ '@/components/modules/landing/components/Churn'
  );
const PracticeSkillsScreen = () =>
  import(
    /* webpackChunkName: "practiceSkills" */ '@/components/modules/landing/components/PracticeSkills'
  );
const DownloadScreen = () =>
  import(
    /* webpackChunkName: "downloadScreen" */ '@/components/modules/landing/components/DownloadScreen'
  );
  // /* webpackChunkName: "AuthenticationScreen" */ '@/components/modules/landing/components/AuthenticationScreen'
const AuthenticationScreen = () =>
  import(
    /* webpackChunkName: "AuthenticationScreen" */ '@/components/modules/authenticate/AuthenticationScreen'
  );
const RedirectScreen = () =>
  import(
    /* webpackChunkName: "RedirectScreen" */ '@/components/modules/landing/components/RedirectScreen'
  );
// Module: Island
const Island = () =>
  import(
    /* webpackChunkName: "islandScreen" */ '@/components/modules/island/IslandScreen'
  );
const IslandThematic = () =>
  import(
    /* webpackChunkName: "islandThematic" */ '@/components/modules/lessons/components/IslandThematic'
  );

const LessonFlowScreen = () =>
  import(
    /* webpackChunkName: "lessonFlowScreen" */ '@/components/modules/lessons/LessonFlowScreen'
  );

const LessonFlowScreenWithoutUser = () =>
  import(
    /* webpackChunkName: "lessonFlowScreen" */ '@/components/modules/lessons/LessonFlowScreenWithoutUser'
  );

// Module: Library
const Library = () =>
  import(
    /* webpackChunkName: "libraryScreen" */ '@/components/modules/library/LibraryScreen'
  );
const Catalogue = () =>
  import(
    /* webpackChunkName: "catalogue" */ '@/components/modules/library/components/Catalogue'
  );
const WordBuilder = () =>
  import(
    /* webpackChunkName: "wordBuilder" */ '@/components/modules/library/components/WordBuilder'
  );
const WordBuilderCategory = () =>
  import(
    /* webpackChunkName: "wordBuilderCategory" */ '@/components/modules/library/components/WordBuilderCategory'
  );
const WordBuilderWordsScreen = () =>
  import(
    /* webpackChunkName: "wordBuilderWordsScreen" */ '@/components/modules/library/components/WordBuilderWordsScreen'
  );
const GrammarScreen = () =>
  import(
    /* webpackChunkName: "grammarScreen" */ '@/components/modules/grammar/GrammarScreen'
  );

// Module: Teachbot
const TeachBot = () =>
  import(
    /* webpackChunkName: "teachBot" */ '@/components/modules/teachbot/TeachBot'
  );
const TeachBotScreen = () =>
  import(
    /* webpackChunkName: "teachbotScreen" */ '@/components/modules/teachbot/TeachBotScreen'
  );

const OnboardingScreen = () =>
  import(
    /* webpackChunkName: "onboardingScreen" */ '@/components/modules/onboarding/OnboardingScreen'
  );

// Module: Profile
const ProfileScreen = () =>
  import(
    /* webpackChunkName: "profileScreen" */ '@/components/modules/profile/ProfileScreen'
  );
const FriendProfileScreen = () =>
  import(
    /* webpackChunkName: "friendProfileScreen" */ '@/components/modules/profile/FriendProfileScreen'
  );
const ShopScreen = () =>
  import(
    /* webpackChunkName: "shopScreen" */ '@/components/modules/shop/ShopScreen'
  );

// Module: Settings
const SettingsScreen = () =>
  import(
    /* webpackChunkName: "settingsScreen" */ '@/components/modules/settings/SettingsScreen'
  );

// Module: Classes
const ClassroomDetailsScreen = () =>
  import(
    /* webpackChunkName: "ClassroomDetailsScreen" */ '@/components/modules/classes/ClassroomDetailsScreen'
  );

// Page not found
const PageNotFoundScreen = () =>
  import(
    /* webpackChunkName: "pageNotFound" */ '@/components/shared/PageNotFound'
  );

// DKT Authentication screen
const DKTAuthenticationScreen = () =>
  import('@/components/shared/DKTAuthenticationScreen');

// DKT Redirect screen
const DKTRedirectScreen = () => import('@/components/shared/DKTRedirectScreen');

// Not compatible page
const NotCompatibleScreen = () =>
  import(
    /* webpackChunkName: "notCompatible" */ '@/components/shared/NotCompatible'
  );

const KHEmailVerifiedOrFailedScreen = () =>
import(
  '@/components/modules/onboarding/khcomponents/KHEmailVerifiedOrFailedScreen'
);

const KhHelpScreen = () =>
import(
  '@/components/modules/khHelp/KhHelpScreen'
);

// Neptun Redirect screen
const NeptunRedirectScreen = () => import('@/components/modules/landing/components/NeptunRedirectScreen');
const NeptunTransferScreen = () => import('@/components/modules/landing/components/NeptunTransferScreen');


Vue.use(Router);

const withoutAuthentication = [
  'ErrorPages',
  'LandingScreen',
  'Onboarding',
  'Classroom',
  'KHVerification',
];

const handle2AFlow = (currentRoute, from, next) => {
  const acceptedRoutes = [
    'ClassroomDetailsScreen',
    'DKTAuthenticationScreen',
    'LessonFlowScreen',
    'OnboardingScreen',
    'Lesson',
    'TeachBot',
  ];
  if (!acceptedRoutes.includes(currentRoute)) {
    if (from) {
      next({ name: 'OnboardingScreen' });
    } else {
      next({
        name: 'ClassroomDetailsScreen',
        params: {
          classId: store.getters['settings/getDktOptions'].classId,
        },
      });
    }
  } else {
    next();
  }
};

const lockToOnboarding = (next) => {
  next('/onboarding');
};

const handleDktFlows = (to, from, next) => {
  const dktOptions = store.getters['settings/getDktOptions'];
  const availableRouteNames = [
    'AuthenticationScreen',
    'DKTAuthenticationScreen',
    'DKTRedirectScreen',
    'RedirectScreen',
    'OnboardingScreen',
  ];
  if (
    !(availableRouteNames.includes(to.name) || to.meta.group == 'Onboarding')
  ) {
    if (dktOptions.classId) {
      handle2AFlow(to.name, from.name, next);
    } else {
      lockToOnboarding(next);
    }
  } else {
    next();
  }
};

// eslint-disable-next-line
const guard = (to, from, next) => {
  if (to.name === 'AndroidCustomProductRedirectTechnical') {
    location.replace('https://play.google.com/store/apps/details?id=com.application.xeropan&listing=it-engineering-tech-english');
  }
  if (to.name === 'AndroidCustomProductRedirectBusiness') {
    location.replace('https://play.google.com/store/apps/details?id=com.application.xeropan&listing=business_english');
  }
  if (to.name === 'PageNotFoundScreen') {
    store.dispatch('settings/setPageNotFound', true);
    // store.state.settings.isPageNotFound = true;
    return;
  }
  if (to.name === 'KhHelpScreen' && (store.getters['users/loggedInUserProfile'].user.isKHUser)) {
    store.dispatch('settings/setPageNotFound', true);
    return;
  }
  store.dispatch('settings/setPageNotFound', false);
  // store.state.settings.isPageNotFound = false;
  const user = store.getters['users/loggedInUserProfile'].user;
  const hasToken = store.getters.hasToken;
  if (to.name === 'LandingScreen' && hasToken) {
    next({ name: Island });
  }
  if (
    store.getters['users/isKretaUser'] &&
    (to.path.includes('invitation') || to.name === 'FriendProfileScreen')
  ) {
    next('/');
  } else if (
    store.getters['users/isKretaUser'] &&
    !store.getters['users/isKHUser'] &&
    !store.getters['users/isNeptunUser'] &&
    store.getters.hasToken &&
    user.registrationStatus !== 'registered' &&
    !location.href.includes('x-key')
  ) {
    handleDktFlows(to, from, next);
  } else if (from.name == 'ZeroPasswordVerifiedOrFailed') {
    // eslint-disable-next-line
    return;
  } else if (store.getters.hasToken) {
      next({ name: Island });
  } else if (to.path === '/' || withoutAuthentication.includes(to.meta.group)) {
    next();
  } else {
    next('/');
  }
};

const router = new Router({
  // mode: (process.env.NODE_ENV === 'development' ? 'hash' : 'history'),
  mode: 'history',
  routes: [
    {
      path: '/',
      name:
        store.getters.hasToken &&
        (store.state.settings.userSettings.finishedOnboarding === true ||
          store.state.users.loggedInUserProfile.user.registrationStatus ===
            'registered' ||
          store.getters.registrationStatus === 'registered')
          ? 'Island'
          : 'LandingScreen',
      component:
        store.getters.hasToken &&
        (store.state.settings.userSettings.finishedOnboarding === true ||
          store.state.users.loggedInUserProfile.user.registrationStatus ===
            'registered' ||
          store.getters.registrationStatus === 'registered')
          ? Island
          : LandingScreen,
      alias: ['/notifications', '/auth'],
      props: true,
      meta: {
        group:
          store.getters.hasToken &&
          (store.state.settings.userSettings.finishedOnboarding === true ||
            store.state.users.loggedInUserProfile.user.registrationStatus ===
              'registered' ||
            store.getters.registrationStatus === 'registered')
            ? 'Island'
            : 'LandingScreen',
        options: {
          sidebar:
            store.getters.hasToken &&
            (store.state.settings.userSettings.finishedOnboarding === true ||
              store.state.users.loggedInUserProfile.user.registrationStatus ===
                'registered' ||
              store.getters.registrationStatus === 'registered'),
        },
        breadcrumb: [
          {
            link: 'Island',
          },
        ],
      },
    },
    {
      path: '/skills',
      name: 'Library',
      component: Library,
      meta: {
        group: 'Library',
        options: {
          sidebar: true,
        },
        breadcrumb: [
          {
            name: 'app.routes.library.name',
            link: 'Library',
            closePopper: true,
          },
        ],
      },
    },
    {
      path: '/skills/learn-words',
      name: 'Word Builder',
      component: WordBuilder,
      meta: {
        group: 'Library',
        options: {
          sidebar: true,
        },
        breadcrumb: [
          {
            name: 'app.routes.library.name',
            link: 'Library',
          },
          {
            name: 'app.routes.wordBuilder.name',
            link: 'Word Builder',
          },
        ],
      },
    },
    {
      path: '/skills/learn-words/category/:category',
      name: 'Word Builder Category',
      component: WordBuilderCategory,
      meta: {
        group: 'Library',
        options: {
          sidebar: true,
        },
        breadcrumb: [
          {
            name: 'app.routes.library.name',
            link: 'Library',
          },
          {
            name: 'app.routes.wordBuilder.name',
            link: 'Word Builder',
          },
          {
            name: 'app.routes.wordBuilderCategory.name',
            link: 'Word Builder Category',
          },
        ],
      },
    },
    {
      path: '/skills/learn-words/favorite-words',
      name: 'Word Builder Favorite Words',
      component: WordBuilderWordsScreen,
      meta: {
        group: 'Library',
        isFavourite: true,
        options: {
          sidebar: true,
        },
        breadcrumb: [
          {
            name: 'app.routes.library.name',
            link: 'Library',
          },
          {
            name: 'app.routes.wordBuilder.name',
            link: 'Word Builder',
          },
          {
            name: 'app.routes.wordBuilderFavoriteWordsScreen.name',
            link: 'Word Builder Favorite Words',
          },
        ],
      },
    },
    {
      path: '/skills/learn-words/:expressionStatus',
      name: 'ExpressionLearner',
      component: WordBuilderWordsScreen,
      meta: {
        group: 'Library',
        options: {
          sidebar: true,
        },
        breadcrumb: [
          {
            name: 'app.routes.library.name',
            link: 'Library',
          },
          {
            name: 'app.routes.wordBuilder.name',
            link: 'Word Builder',
          },
          {
            name: 'app.routes.wordBuilderWordsScreen.name',
            link: 'ExpressionLearner',
          },
        ],
      },
    },
    {
      path: '/skills/catalog',
      name: 'Catalogue',
      component: Catalogue,
      meta: {
        group: 'Library',
        options: {
          sidebar: true,
        },
        breadcrumb: [
          {
            name: 'app.routes.library.name',
            link: 'Library',
            closePopper: true,
          },
          {
            name: 'app.routes.catalog.name',
            link: 'Catalogue',
            closePopper: true,
          },
        ],
      },
    },
    {
      path: '/skills/speaking-practice',
      name: 'Teach Bot Screen',
      component: TeachBotScreen,
      meta: {
        group: 'Library',
        options: {
          sidebar: true,
        },
        breadcrumb: [
          {
            name: 'app.routes.library.name',
            link: 'Library',
          },
          {
            name: 'app.routes.teachBot.name',
            link: 'Teach Bot Screen',
          },
        ],
      },
    },
    {
      path: '/skills/grammar-guide',
      name: 'Grammar Screen',
      component: GrammarScreen,
      meta: {
        group: 'Library',
        options: {
          sidebar: true,
        },
        breadcrumb: [
          {
            name: 'app.routes.library.name',
            link: 'Library',
          },
          {
            name: 'app.routes.grammar.name',
            link: 'Grammar Screen',
          },
        ],
      },
    },
    {
      path: '/topics/:id/lessons',
      name: 'Thematic',
      component: IslandThematic,
      meta: {
        group: 'Island',
        options: {
          sidebar: true,
        },
        breadcrumb: [
          {
            name: 'app.routes.island.name',
            link: 'Island',
          },
          {
            name: 'app.routes.thematic.name',
            link: 'Thematic',
            closePopper: true,
          },
        ],
      },
    },
    {
      path: '/lessons/:id?/',
      name: 'Lesson',
      component: LessonFlowScreen,
      meta: {
        group: 'Island',
        options: {
          sidebar: true,
        },
        breadcrumb: [
          {
            name: 'app.routes.lesson.name',
            link: 'Lesson',
          },
        ],
      },
    },
    {
      path: '/conversations/:id',
      name: 'TeachBot',
      component: TeachBot,
      meta: {
        group: 'Library',
        options: {
          sidebar: false,
        },
        breadcrumb: [
          {
            name: 'app.routes.chat.name',
            link: 'TeachBot',
          },
        ],
      },
    },
    {
      path: '/onboarding',
      name: 'OnboardingScreen',
      component: OnboardingScreen,
      meta: {
        group: 'Onboarding',
        options: {
          sidebar: false,
        },
        breadcrumb: [
          {
            name: 'app.routes.onboarding.name',
            link: 'Onboarding',
          },
        ],
      },
    },
    {
      path: '/profile',
      name: 'ProfileScreen',
      component: ProfileScreen,
      alias: [
        '/profile/friends',
        '/profile/weekly-contest',
        '/profile/closed-weekly-contest',
      ],
      meta: {
        group: 'Profile',
        options: {
          sidebar: true,
        },
        breadcrumb: [
          {
            name: 'app.routes.profile.name',
            link: 'Profile',
          },
        ],
      },
    },
    {
      path: '/profile/my-classes',
      name: 'ProfileScreenMyClasses',
      component: ProfileScreen,
      meta: {
        group: 'Profile',
        options: {
          sidebar: true,
        },
      },
    },
    {
      path: '/users/:userId',
      name: 'FriendProfileScreen',
      component: FriendProfileScreen,
      props: {
        isPopper: true,
      },
      meta: {
        group: 'Profile',
        options: {
          sidebar: false,
        },
        breadcrumb: [
          {
            name: 'app.routes.profile.name',
            link: 'Profile',
          },
        ],
      },
    },
    {
      path: '/pro',
      name: 'ShopScreen',
      component: ShopScreen,
      meta: {
        group: 'Shop',
        options: {
          sidebar: true,
        },
        breadcrumb: [
          {
            name: 'app.routes.shop.name',
            link: 'Shop',
          },
        ],
      },
    },
    {
      path: '/pro/cards',
      name: 'Cards',
      component: ShopScreen,
      meta: {
        group: 'Shop',
        options: {
          sidebar: true,
        },
        isCards: true,
        breadcrumb: [
          {
            name: 'app.routes.shop.name',
            link: 'Shop',
          },
        ],
      },
    },
    {
      path: '/about-us/',
      name: 'AboutUsScreen',
      component: AboutUsScreen,
      meta: {
        group: 'LandingScreen',
        options: {
          sidebar: false,
        },
      },
    },
    {
      path: '/practice/',
      name: 'PracticeSkillsScreen',
      component: PracticeSkillsScreen,
      meta: {
        group: 'LandingScreen',
        options: {
          sidebar: false,
        },
      },
    },
    {
      path: '/career/',
      name: 'CareerScreen',
      component: CareerScreen,
      meta: {
        group: 'LandingScreen',
        options: {
          sidebar: false,
        },
      },
    },
    {
      path: '/press/',
      name: 'PressScreen',
      component: PressScreen,
      meta: {
        group: 'LandingScreen',
        options: {
          sidebar: false,
        },
      },
    },
    {
      path: '/privacy-policy/',
      name: 'PrivacyScreen',
      component: PrivacyScreen,
      alias: ['/archive/privacy-policy'],
      meta: {
        group: 'LandingScreen',
        options: {
          sidebar: false,
        },
      },
    },
    {
      path: '/terms-and-conditions/',
      name: 'GeneralTermsScreen',
      component: GeneralTermsScreen,
      alias: ['/archive/terms-and-conditions'],
      meta: {
        group: 'LandingScreen',
        options: {
          sidebar: false,
        },
      },
    },
    {
      path: '/team/',
      name: 'TeamScreen',
      component: TeamScreen,
      meta: {
        group: 'LandingScreen',
        options: {
          sidebar: false,
        },
      },
    },
    {
      path: '/settings',
      name: 'SettingsScreen',
      alias: [
        '/settings/languages',
        '/settings/pro',
        '/settings/join',
        '/settings/notification',
        '/settings/accessibility',
      ],
      component: SettingsScreen,
      meta: {
        group: 'Settings',
        options: {
          sidebar: false,
        },
        breadcrumb: [
          {
            name: 'app.routes.settings.name',
          },
        ],
      },
    },
    {
      path: '/page-not-found',
      name: 'PageNotFoundScreen',
      component: PageNotFoundScreen,
      meta: {
        group: 'ErrorPages',
        options: {
          needHeader: store.getters.hasToken,
          sidebar: false,
        },
      },
    },
    {
      path: '/not-compatible',
      name: 'NotCompatibleScreen',
      component: NotCompatibleScreen,
      meta: {
        group: 'ErrorPages',
        options: {
          needHeader: store.getters.hasToken,
          sidebar: false,
        },
      },
    },
    {
      path: '/business',
      name: 'BusinessScreen',
      component: BusinessScreen,
      meta: {
        group: 'LandingScreen',
        options: {
          sidebar: false,
        },
      },
    },
    {
      path: '/pricing',
      name: 'PricingScreen',
      component: PricingScreen,
      meta: {
        group: 'LandingScreen',
        options: {
          sidebar: false,
        },
      },
    },
    {
      path: '/lessons/expressions/:expressionType/:expressionStatus',
      name: 'Lesson',
      component: LessonFlowScreen,
      meta: {
        group: 'Island',
        options: {
          sidebar: true,
        },
        breadcrumb: [
          {
            name: 'app.routes.lesson.name',
            link: 'Lesson',
          },
        ],
        expressions: true,
      },
    },
    {
      path:
        '/lessons/expressions/:expressionType/:expressionStatus/:expressionTagId',
      name: 'Lesson',
      component: LessonFlowScreen,
      meta: {
        group: 'Island',
        options: {
          sidebar: true,
        },
        breadcrumb: [
          {
            name: 'app.routes.lesson.name',
            link: 'Lesson',
          },
        ],
        expressions: true,
      },
    },
    {
      path: '/lessons/level/:level',
      name: 'Lesson',
      component: LessonFlowScreen,
      meta: {
        group: 'Island',
        options: {
          sidebar: false,
        },
        levelUp: true,
      },
    },
    {
      path: '/onboarding/placement-test',
      name: 'Lesson',
      alias: ['/placement-test'],
      component: LessonFlowScreen,
      meta: {
        group: 'Onboarding',
        options: {
          sidebar: false,
        },
        placement: true,
      },
    },
    {
      path: '/subscribe',
      name: 'SubscribeScreen',
      component: SubscribeScreen,
      meta: {
        group: 'LandingScreen',
        options: {
          sidebar: false,
        },
      },
    },
    {
      path: '/unsubscribedA',
      name: 'UnsubscribedScreen',
      component: UnsubscribedScreen,
      meta: {
        group: 'LandingScreen',
        options: {
          sidebar: false,
        },
      },
    },
    {
      path: '/unsubscribedB',
      name: 'UnsubscribedScreen',
      component: UnsubscribedScreen,
      meta: {
        group: 'LandingScreen',
        options: {
          sidebar: false,
        },
      },
    },
    {
      path: '/unsubscribe',
      name: 'UnsubscribeChooserScreen',
      component: UnsubscribeChooserScreen,
      meta: {
        group: 'LandingScreen',
        options: {
          sidebar: false,
        },
      },
    },
    {
      path: '/invitation/:code?',
      name: 'InvitationScreen',
      component: InvitationScreen,
      alias: ['/join/:code?', '/join'],
      meta: {
        group: 'LandingScreen',
        options: {
          sidebar: false,
        },
      },
    },
    {
      path: '/:language_code/cs123.html',
      name: 'ChurnScreen',
      component: ChurnScreen,
      meta: {
        group: 'LandingScreen',
        url: 'app.landing.churn.feedback.url',
        options: {
          sidebar: false,
        },
      },
    },
    {
      path: '/:language_code/cs4.html',
      name: 'ChurnScreen',
      component: ChurnScreen,
      meta: {
        group: 'LandingScreen',
        url: 'app.landing.churn.reply.url',
        options: {
          sidebar: false,
        },
      },
    },
    {
      path: '/download/',
      name: 'DownloadScreen',
      component: DownloadScreen,
      meta: {
        group: 'LandingScreen',
        options: {
          sidebar: false,
        },
      },
    },
    {
      path: '/classes/:classId',
      name: 'ClassroomDetailsScreen',
      component: ClassroomDetailsScreen,
      // alias:['/classes/:classId/leaderboard'],
      meta: {
        group: 'ClassroomDetailsScreen',
        options: {
          sidebar: true,
        },
        breadcrumb: [
          {
            name: 'app.classroomDetailsScreen.breadcrumb.myClasses',
            link: 'ProfileScreenMyClasses',
            closePopper: true,
          },
        ],
      },
    },
    {
      path: '/classroom/lessons/:id?/',
      name: 'Lesson',
      component: LessonFlowScreenWithoutUser,
      meta: {
        group: 'Classroom',
        options: {
          sidebar: false,
        },
        breadcrumb: [
          {
            name: 'app.routes.lesson.name',
            link: 'Lesson',
          },
        ],
      },
    },
    {
      path: '/dkt/redirect',
      name: 'DKTRedirectScreen',
      component: DKTRedirectScreen,
      meta: {
        group: 'LandingScreen',
        options: {
          sidebar: false,
        },
      },
    },
    {
      path: '/dkt/sso',
      name: 'DKTAuthenticationScreen',
      component: DKTAuthenticationScreen,
      meta: {
        group: 'LandingScreen',
        options: {
          sidebar: false,
        },
      },
    },
    {
      path: '/login/',
      name: 'AuthenticationScreen',
      alias: ['/register/'],
      component: AuthenticationScreen,
      meta: {
        group: 'LandingScreen',
        options: {
          sidebar: false,
        },
      },
    },
    {
      path: '/dkt-redirect',
      name: 'RedirectScreen',
      component: RedirectScreen,
      meta: {
        group: 'LandingScreen',
        options: {
          sidebar: false,
        },
      },
    },
    {
      path: '/classroom/conversations/:id?/',
      name: 'Teachbot',
      component: TeachBot,
      meta: {
        group: 'Classroom',
        options: {
          sidebar: false,
        },
        breadcrumb: [
          {
            name: 'app.routes.lesson.name',
            link: 'Lesson',
          },
        ],
      },
    },
    // {
    //   path: '/archive/privacy-policy',
    //   name: 'PrivacyScreen',
    //   component: PrivacyScreen,
    //   meta: {
    //     group: 'LandingScreen',
    //     options: {
    //       sidebar: false,
    //     },
    //   },
    // },
    {
      path: '/zero-password/success',
      name: 'ZeroPasswordVerifiedOrFailed',
      component: KHEmailVerifiedOrFailedScreen,
      meta: {
        group: 'KHVerification',
      },
    },
    {
      path: '/zero-password/error',
      name: 'ZeroPasswordVerifiedOrFailed',
      component: KHEmailVerifiedOrFailedScreen,
      meta: {
        group: 'KHVerification',
      },
    },
    {
      path: '/help',
      name: 'KhHelpScreen',
      component: KhHelpScreen,
      meta: {
        group: 'KhHelpScreen',
        options: {
          sidebar: true,
        },
      },
    },
    {
      path: '/redirect-android-business_english',
      name: 'AndroidCustomProductRedirectBusiness',
    },
    {
      path: '/redirect-android-technical_english',
      name: 'AndroidCustomProductRedirectTechnical',
    },
    { path: '*', redirect: '/page-not-found' },
    {
      path: '/neptun-redirect',
      name: 'NeptunRedirectScreen',
      component: NeptunRedirectScreen,
      meta: {
        group: 'LandingScreen',
        options: {
          sidebar: false,
        },
      },
    },
    {
      path: '/transfer',
      name: 'NeptunTransferScreen',
      component: NeptunTransferScreen,
      meta: {
        group: 'LandingScreen',
        options: {
          sidebar: false,
        },
      },
    },
  ],
});

router.beforeEach(guard);

export default router;
